// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Uganda */
const UG = /^(?:7280\d{5}|7(?:[014-8]\d|2[01467]|3[0167]|9[0-589])\d{6})$/;

export default UG;
